import { Paper, Text } from "@mantine/core"

interface FormSectionProps {
  title: React.ReactNode
  accentColor?: string
  children: React.ReactNode
}

export default function FormSection({ title, accentColor = "blue", children }: FormSectionProps) {
  return (
    <Paper
      withBorder
      p="md"
      style={{
        borderLeft: `4px solid var(--mantine-color-${accentColor}-5)`,
      }}
    >
      <Text fw={600} size="sm" c={accentColor} mb="md" tt="uppercase" lts="0.05em">
        {title}
      </Text>
      {children}
    </Paper>
  )
}
